import { Component, ViewChild } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TopNavComponent } from "../top-nav/top-nav.component";
import { MatSidenav, MatSidenavContainer, MatSidenavModule } from '@angular/material/sidenav';
import { SideNavComponent } from "../side-nav-left/side-nav/side-nav.component";
import { CommonModule } from "@angular/common";
import { SideNavClosedComponent } from "../side-nav-left/side-nav-closed/side-nav-closed.component";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.css"],
  imports: [
    RouterModule,
    TopNavComponent,
    MatSidenavModule,
    SideNavComponent,
    CommonModule,
    SideNavClosedComponent
  ],
  standalone: true,
})
export class LayoutComponent {
  title = 'Material-Side-Navbar-In-Angular';

  @ViewChild(MatSidenavContainer) sidenavContainer!: MatSidenavContainer;
  @ViewChild('snav') sideNav!: MatSidenav;

  sideNavDefaultOpened = true;
  showFullMenu = true;
  isExpanded = true;
  closedWidth = 90;
  openedWidth = 250;
  isMobile!: boolean;
  sideNavMode: 'side' | 'over' = 'side';
  hasBackdrop: boolean = false;
  toolBarHeight = 64;
  isDarkTheme: boolean = false;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe(result => {
      if (result.matches) {
        // Mobile view
        this.isMobile = true;
        this.sideNavDefaultOpened = false;
        this.isExpanded = false;
        this.showFullMenu = true;
        this.sideNavMode = 'over';
        this.hasBackdrop = true;
        this.toolBarHeight = 56;
      } else {
        // Desktop view
        this.isMobile = false;
        this.sideNavDefaultOpened = true;
        this.sideNavMode = 'side';
        this.hasBackdrop = false;
        this.toolBarHeight = 64;
      }
    });
  }

  ngAfterViewInit(): void {
    this.sidenavContainer.scrollable.elementScrolled().subscribe(() => {});
  }

  ngOnInit() {}

  ngOnDestroy(): void {}

  onToolbarMenuToggle() {
    if (this.isMobile) {
      this.sideNav.toggle();
    } else {
      this.showFullMenu = !this.isExpanded;
    }
    this.isExpanded = !this.isExpanded;
  }

   closeSidebar() {
    if (this.sideNav.mode !== 'side') {
      this.sideNav.close();
      this.isExpanded = !this.isExpanded;
      // this.showFullMenu = this.isExpanded;
    }
  }
}
